import { useAjax, useMzMutation, useTranslations } from "@harea/component";

export const useCreateDebauchageMutation = () => {
  const ajax = useAjax();
  const [CREATE_ERROR] = useTranslations(i18n);
  return useMzMutation<any>(
    (payload: Record<string, any>) =>
      ajax.send({
        type: "POST",
        content_type: "application/json",
        url: "debauchage/create",
        data: payload,
      }),
    {
      transformErrorMessage: (error: any) => {
        const message = error?.message || error?.response?.message;
        return message || CREATE_ERROR;
      },
    }
  );
};

const i18n = ["std_debauchage_create_error"];
